"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowIcon = void 0;
var React = require("react");
var classNames = require("classnames");
var Icon_1 = require("components/Icon");
require("./styles.scss");
var TableRowIcon = function (props) { return (React.createElement("span", { title: props.title, onClick: (!props.disabled && props.onClick) || undefined, className: classNames('fa-stack table-row-icon', props.disabled ? 'disabled' : props.className, typeof props.onClick === 'function' && !props.disabled && 'selectable') },
    props.circle && (React.createElement(Icon_1.Icon, { className: classNames('fa-circle fa-stack-1x', props.disabled && 'disabled') })),
    props.square && (React.createElement(Icon_1.Icon, { className: classNames('fa-square fa-stack-1x', props.disabled && 'disabled') })),
    React.createElement(Icon_1.Icon, { className: classNames(props.icon ? props.icon : 'fa-times', props.icon && /fa-/.test(props.icon) && 'fa-stack-1x', props.disabled && 'disabled') }))); };
exports.TableRowIcon = TableRowIcon;
exports.default = exports.TableRowIcon;
